/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const PlusFolderIcon = ({
  className,
  style,
  color = '#938BB7',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M10.75 6.5H8.5V4.25C8.5 4.11188 8.38813 4 8.25 4H7.75C7.61188 4 7.5 4.11188 7.5 4.25V6.5H5.25C5.11188 6.5 5 6.61188 5 6.75V7.25C5 7.38812 5.11188 7.5 5.25 7.5H7.5V9.75C7.5 9.88813 7.61188 10 7.75 10H8.25C8.38813 10 8.5 9.88813 8.5 9.75V7.5H10.75C10.8881 7.5 11 7.38812 11 7.25V6.75C11 6.61188 10.8881 6.5 10.75 6.5ZM6.08563 1L7.79281 2.70719C7.98031 2.89469 8.23469 3 8.5 3H14.5C14.7762 3 15 3.22375 15 3.5V10.5C15 10.7762 14.7762 11 14.5 11H1.5C1.22375 11 1 10.7762 1 10.5V1.5C1 1.22375 1.22375 1 1.5 1H6.08563ZM1.5 0C0.671562 0 0 0.671562 0 1.5V10.5C0 11.3284 0.671562 12 1.5 12H14.5C15.3284 12 16 11.3284 16 10.5V3.5C16 2.67156 15.3284 2 14.5 2H8.5L6.79281 0.292813C6.60531 0.105313 6.35094 0 6.08563 0H1.5Z"
        fill={color}
      />
    </svg>
  );
};
